// src/pages/LoginPage.js (Versión Completa y Funcional con enlace a Registro)
import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate, Link } from 'react-router-dom'; // Importamos Link de react-router-dom
import { 
  Container, 
  Box, 
  TextField, 
  Button, 
  Typography, 
  Paper,
  CircularProgress,
  Grid // Importamos Grid para alinear el enlace
} from '@mui/material';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  const auth = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await auth.login(username, password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
     <Container component="main" maxWidth="xs">
       <Paper 
         elevation={6} 
         sx={{ 
           marginTop: 8, 
           display: 'flex', 
           flexDirection: 'column', 
           alignItems: 'center',
           padding: 4,
         }}
       >
         <Box
           component="img"
           sx={{ height: 80, marginBottom: 2 }}
           alt="PackageRoute Logo"
           src="/packageroute_logo.png"
         />
         <Typography component="h1" variant="h5">
           Admin Portal Login
         </Typography>
         <Box component="form" onSubmit={handleLogin} noValidate sx={{ mt: 1 }}>
           <TextField
             margin="normal"
             required
             fullWidth
             id="username"
             label="Username"
             name="username"
             autoComplete="username"
             autoFocus
             value={username}
             onChange={(e) => setUsername(e.target.value)}
           />
           <TextField
             margin="normal"
             required
             fullWidth
             name="password"
             label="Password"
             type="password"
             id="password"
             autoComplete="current-password"
             value={password}
             onChange={(e) => setPassword(e.target.value)}
           />
           {error && (
             <Typography color="error" variant="body2" sx={{ mt: 2 }}>
               {error}
             </Typography>
           )}
           <Button
             type="submit"
             fullWidth
             variant="contained"
             sx={{ mt: 3, mb: 2 }}
             disabled={loading}
           >
             {loading ? <CircularProgress size={24} /> : 'Sign In'}
           </Button>
           {/* --- NUEVO BLOQUE DE ENLACE --- */}
           <Grid container justifyContent="flex-end">
             <Grid item>
               <Link to="/register" style={{ color: '#0083BF', textDecoration: 'none' }}>
                 Don't have an account? Register
               </Link>
             </Grid>
           </Grid>
           {/* --- FIN DEL NUEVO BLOQUE --- */}
         </Box>
       </Paper>
     </Container>
  );
};

export default LoginPage;
